import { render, staticRenderFns } from "./ModalGenerico.vue?vue&type=template&id=6fe388f8&"
import script from "./ModalGenerico.vue?vue&type=script&lang=js&"
export * from "./ModalGenerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports